import React from "react";

const TicketDetails = ({ ticket }) => {
  return (
    <blockquote className="blockquote">
      {ticket.description}
    </blockquote>
  );
};

export default TicketDetails;
